/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_Setup_LinkInputs */

const en_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up search criteria to start finding jobs`)
};

const de_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richte Suchkriterien ein, um Stellen zu finden`)
};

const fr_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure des critères de recherche pour commencer à trouver des emplois`)
};

const es_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure criterios de búsqueda para empezar a encontrar empleos`)
};

const it_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura i criteri di ricerca per iniziare a trovare lavori`)
};

const nl_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel zoekcriteria in om banen te vinden`)
};

const pl_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skonfiguruj kryteria wyszukiwania, aby zacząć znajdować oferty`)
};

const fi_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aseta hakukriteerit aloittaaksesi työpaikkojen etsimisen`)
};

const da_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsæt søgekriterier for at begynde at finde job`)
};

const sv_jobs_search_criteria_setup_link = /** @type {(inputs: Jobs_Search_Criteria_Setup_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ställ in sökkriterier för att börja hitta jobb`)
};

/**
* | output |
* | --- |
* | "Set up search criteria to start finding jobs" |
*
* @param {Jobs_Search_Criteria_Setup_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_setup_link = /** @type {((inputs?: Jobs_Search_Criteria_Setup_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_Setup_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_setup_link(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_setup_link(inputs)
	if (locale === "es") return es_jobs_search_criteria_setup_link(inputs)
	if (locale === "it") return it_jobs_search_criteria_setup_link(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_setup_link(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_setup_link(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_setup_link(inputs)
	if (locale === "da") return da_jobs_search_criteria_setup_link(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_setup_link(inputs)
	return en_jobs_search_criteria_setup_link(inputs)
});